import { apiClient } from './apiClient';

// --- Types ---

export interface Theme {
  id: string;
  tenant_id: string;
  name: string;
  category: string;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export interface ThemesListResponse {
  items: Theme[];
  total: number;
  limit: number;
  offset: number;
}

// --- API ---

export const themesApi = apiClient.injectEndpoints({
  endpoints: (builder) => ({
    listSiteThemes: builder.query<ThemesListResponse, { siteId: string }>({
      query: ({ siteId }) => ({
        url: `/api/v1/sites/${siteId}/themes`,
        method: 'GET',
      }),
      providesTags: (result, _error, { siteId }) =>
        result
          ? [
              ...result.items.map(({ id }) => ({ type: 'Theme' as const, id })),
              { type: 'Theme' as const, id: `LIST-${siteId}` },
            ]
          : [{ type: 'Theme' as const, id: `LIST-${siteId}` }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useListSiteThemesQuery,
} = themesApi;
